import React from "react";
import { useAuth } from "../../Context/authContext";
import StudentIdeasReview from "./StudentIdeasReview";
import MentorIdeasReview from "./MentorIdeasReview";

const Component = () => {
  const { user } = useAuth();

  // Route to appropriate component based on user role
  if (user?.role === 'mentor') {
    return <MentorIdeasReview />;
  }

  // Default to student flow
  return <StudentIdeasReview />;
};

export default Component;
